export enum Layouts {
    SIDEBAR_RIGHT,
    FULL_WIDTH,
}
